import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
	L10nTranslatePipe,
	L10N_LOCALE, L10nLocale, L10N_CONFIG, L10nConfig, L10nTranslationService
} from 'angular-l10n';
import {RestService} from "../immerdrin/rest.service.interface";
import {RestServiceImpl} from "../immerdrin/rest.service.impl";
import {InsertEditMitDialogs} from "../immerdrin/bearbeitung/insertEdit.mitDialogs";
import {AuthService} from "../../shared/auth.service";
import {LoggerService} from "../../shared/logger.service";
import {SelectFilterUtil} from "../immerdrin/select-filter.util";
import {Frage} from "../fragebogen/frage.model";
import {Antwort} from "../fragebogen/antwort.model";
import {oase_config} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http"; import {FormsModule} from "@angular/forms";
import {APIConfigService} from "../../api.config.service"; import {AngularMaterial2Module} from "../../app.module.material";
import {Kernantwort} from "../../shared/response/kernantwort.model";
import {Httpstatus} from "../../shared/response/httpstatus.model";
import {Observable} from "rxjs";

const PATH_FILE = 'app/protected/verwaltungantworten/antwort.insertEdit.component.ts';

const BACKEND_PATH_PREFIX = 'antwort/';
// const REST_API_BASE =
// 	( window.location.hostname == 'localhost' ? oase_config.restapi.schema + '://' : '' ) + // z.B. http://
// 	( window.location.hostname == 'localhost' ? oase_config.restapi.host : '' ) + // z.B. masterproject.oase.at
// 	( window.location.hostname == 'localhost' ? ( oase_config.restapi.port ? ':' + oase_config.restapi.port : '' ) : '' ) + '/' + // z.B. :80/ oder /
// 	oase_config.restapi.path + '/'; // z.B. masterproject/
// const REST_API =
// 	REST_API_BASE +
// 	BACKEND_PATH_PREFIX; // z.B. tipp/

@Component({
    selector: 'oase-antwort-insertEdit.dialog',
    templateUrl: './antwort.insertEdit.component.html',
    providers: [{ provide: RestService, useExisting: RestServiceImpl }],
    standalone:true,	imports: [AngularMaterial2Module, L10nTranslatePipe, FormsModule  ]

})
export class AntwortInsertEditComponent extends InsertEditMitDialogs {

	canSubmit: boolean = false;
	fehlerMain: Kernantwort = null;

	constructor(
		public dialogRef: MatDialogRef<AntwortInsertEditComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dataService: RestService,
		public apiConfigService: APIConfigService, public http: HttpClient,
		public authService: AuthService,
		public dialog: MatDialog,
		@Inject(L10N_LOCALE) public locale: L10nLocale,
		@Inject(L10N_CONFIG) private config: L10nConfig,
		public translation: L10nTranslationService,
		public _logger: LoggerService) {

		super(dialogRef, data, dataService, authService, apiConfigService, http, dialog, _logger);

	}

	setSubmit(newSubmit: boolean) {

		this.canSubmit = (this.aktuell.text !=null && this.aktuell.text !== '') && newSubmit;
	}

	setzeFehler(fehler: Kernantwort) {
		this.fehlerMain = fehler;
	}


}
